import styled from 'styled-components';
import { BlankSpace } from '../genericComponents/layouts';
import {
  CardTitle, Text4, Text4B, Text3, Text3M,
} from '../genericComponents/texts';
import { priceFormat, roundPrice } from '../priceFormat';
import autoFelizImg from '../assets/img/autoFeliz.svg';
import infoImg from '../assets/img/info.svg';
import PurchasePriceRange from './PurchasePriceRange';

interface Props{
  vehicle:{
    completeName:string,
    clientPrice?: number;
    avgPrice?: number;
    minPrice?: number;
    maxPrice?: number;
    rules?: {
      type: string,
      detail: string,
      discount_value?: number,
    }[];
    region: number;
    public: boolean;
    year?: number;
  }
}

export default function ExpectedResumePrice(props:Props) {
  const { vehicle } = props;
  const baseRule = vehicle.rules?.find((r) => r.type === 'base');
  const normalRule = vehicle.rules?.find((r) => r.type === 'normal');

  if (vehicle.public && vehicle.year && vehicle.year < 2010) {
    return <CardWithoutInfo />;
  }

  return (
    <Container>
      <PurchasePriceRange vehicle={vehicle} />

      <SubCont2>
        {(() => {
          if (!vehicle.public) {
            return (
              <>
                <PaddingCardTitle>
                  <CardTitle>
                    Reglas de retoma
                  </CardTitle>
                </PaddingCardTitle>
                <CarDetails>
                  <Table>
                    <tbody>
                      <tr style={{ backgroundColor: '#F6F6F6' }}>
                        <Tableth>Tipo</Tableth>
                        <Tableth>Detalle</Tableth>
                        <Tableth>Descuento</Tableth>
                      </tr>
                      <tr>
                        <Tabletd>Base</Tabletd>
                        <Tabletd>{baseRule?.detail ? 'Ajuste aplicado por reglas de retoma base' : '-'}</Tabletd>
                        <Tabletd>
                          $
                          {priceFormat(roundPrice(baseRule?.discount_value || 0, 1))}
                        </Tabletd>
                      </tr>
                      <tr>
                        <Tabletd>Normal</Tabletd>
                        <Tabletd>{normalRule?.detail ? 'Ajuste aplicado por reglas de retoma normal' : '-'}</Tabletd>
                        <Tabletd>
                          $
                          {priceFormat(roundPrice(normalRule?.discount_value || 0, 1))}
                        </Tabletd>
                      </tr>
                    </tbody>
                  </Table>
                </CarDetails>
              </>
            );
          }
          return <div />;
        })()}

      </SubCont2>

      <SubCont9>
        <Disclaimer>
          <AutoIconTextContainer>
            <img src={infoImg} width={15} height={15} alt="" />
            <BlankSpace width="15px" />
            <Text3>
              <Text3M>¿Por qué es necesario conocer el precio en parte de pago?</Text3M>
              <BlankSpace width="30px" height="2px" />
              <Text3>
                El precio en parte de pago es aquel que pagan las automotoras o concesionarios cuando las personas los entregan a cambio de un vehículo nuevo. Es importante conocer el precio en parte de pago porque es un valor técnico que sirve como indicador.
              </Text3>
              <BlankSpace width="30px" height="10px" />
              <Text3M>¿Cómo se calcula?</Text3M>
              <BlankSpace width="30px" height="2px" />
              <Text3>
                A través de la aplicación de reglas de descuento al precio de venta Autofact. Se obtiene un precio en parte de pago sugerido para vehículos usados en condiciones normales.
              </Text3>
            </Text3>
          </AutoIconTextContainer>
        </Disclaimer>
      </SubCont9>
    </Container>
  );
}

function CardWithoutInfo() {
  return (
    <ContainerWithoutInfo>
      <SubCont4 style={{
        alignItems: 'center',
        textAlign: 'center',
        marginTop: '20px',
        marginBottom: '20px',
        justifyContent: 'center',
      }}
      >
        <img src={autoFelizImg} width={48} height={48} alt="" />
        <BlankSpace width="10px" height="20px" />
        <Text4B style={{ color: '#0B3254', marginBottom: '10px' }}>
          Lo sentimos, debido a la antigüedad del vehículo, no contamos con información de precio de retoma.
        </Text4B>
        <Text4 style={{ color: '#3D5176', marginBottom: '10px' }}>
          Esta sección solo entrega información para vehículos con año de fabricación a partir de 2010.
        </Text4>
      </SubCont4>
    </ContainerWithoutInfo>
  );
}

const SubCont9 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  @media (max-width: 700px){
    flex-direction: column;
    justify-content: center;
  }
`;

const Disclaimer = styled.div`
  margin: 10px;
  border: 1px solid #EBF1F5;
  border-radius: 10px;
  padding: 10px;
  width: 96%;
  background: #EBF1F5;
  border: 1px solid #8FABC3;
  @media (max-width: 700px){
    width: auto;
  }
`;

const AutoIconTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const SubCont4 = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 700px){
    flex: 1;
  }
`;

const Container = styled.div`
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  @media (max-width: 700px){
    flex-direction: column;
  }
`;

const ContainerWithoutInfo = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
`;

const SubCont2 = styled.div`
  flex: 1;
  padding: 0px 10px;
  @media (max-width: 700px){
    flex:1;
  }
`;

const CarDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-radius: 10px;
  border: 0px solid #EBF1F5;
  @media (max-width: 700px){
    border-radius: 0;
    border:none;
    border-bottom: 1px solid #EBF1F5;
    border-top: 1px solid #EBF1F5;
  }
`;

const Table = styled.table`
  margin: 10px 0 10px 0;
  border: none;
  width: 100%;
  @media (max-width: 700px){
    width: 100%;
  }
`;

const Tableth = styled.th`
  font-size: 14px;
  color: #3D5176;
  font-family: 'Roboto bold';
  text-align: left;
  padding: 10px 15px;
`;

const Tabletd = styled.td`
  font-size: 14px;
  color: #3D5176;
  text-align: left;
  padding: 10px 15px;
  @media (max-width: 700px){
    width: 10%;
    padding: 15px 0;
  }
`;
const PaddingCardTitle = styled.div`
  padding: 10px 0px;
`;
